import type { EnergyLabelData } from './EnergyLabel.types';

import CloudinaryImage from '../../../common/components/atoms/CloudinaryImage';
import styles from './EnergyLabel.module.scss';
import { BADGE_HEIGHT_RATIO, BADGE_WIDTH_PX, getBadgeTransform } from './EnergyLabel.utils';

const EnergyLabelBadgeImage = ({
    energyLabel,
    size = 'default',
    alt,
}: {
    energyLabel: EnergyLabelData;
    size?: 'small' | 'default';
    alt: string;
}) => {
    const widthPx = BADGE_WIDTH_PX[size];
    const heightPx = Math.round(widthPx * BADGE_HEIGHT_RATIO);

    return (
        <CloudinaryImage
            url={energyLabel.smallImageUrl}
            name={energyLabel.energyClass}
            alt={alt}
            transform={getBadgeTransform(widthPx)}
            retinaTransform={getBadgeTransform(widthPx * 2)}
            cssClass={size === 'small' ? styles.BadgeImageSmall : styles.BadgeImage}
            width={widthPx}
            height={heightPx}
        />
    );
};

export default EnergyLabelBadgeImage;
